import { LoadingForm } from '@/app/components/loading/form';

const ERROR_MESSAGE =
  "ไม่รองรับการใช้งานในประเทศของคุณ / Service isn't available in your location.";

interface GoogleMapMessageOverlayProps {
  isError?: boolean;
}

export const GoogleMapMessageOverlay = ({
  isError = false,
}: GoogleMapMessageOverlayProps) => {
  return (
    <div className="bg-azure-50 absolute inset-0 flex items-center justify-center text-center">
      {isError ? ERROR_MESSAGE : <LoadingForm size="3xl" />}
    </div>
  );
};
